import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { ComplaintsProvider } from '../../providers/complaints/complaints';
import { AddComplaintsFormPage } from '../add-complaints-form/add-complaints-form';
import { TranslateService } from '@ngx-translate/core';
import { ToastProvider } from '../../providers/toast/toast';

@IonicPage()
@Component({
  selector: 'page-add-complaints',
  templateUrl: 'add-complaints.html',
})
export class AddComplaintsPage {
  complaintCatagories= [];
  data: any;
  events: any;
  showData = false;
  selRegistrationLogin : any;



  constructor(public navCtrl: NavController, public navParams: NavParams, 
    private complaintsProvider: ComplaintsProvider,
    private translate: TranslateService,
    private toast: ToastProvider,
    private alertController: AlertController) {
    let data = this.navParams.get("categories");

    this.selRegistrationLogin = localStorage.getItem('signup_login')

    if(this.selRegistrationLogin){
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }
else{

    if(!data || data.length == 0){
      complaintsProvider.getComplaintCategory().then(val=> {
        if(val.status == "success"){
          for(var key in val.data){
            this.complaintCatagories.push(val.data[key]);
          }
          this.sortComplaints();
        }
      });
    } else{
      for(var key in data){
        this.complaintCatagories.push(data[key]);
      }
      this.sortComplaints();
    }
    }

    this.events = {
      'onItemClick': function (item: any) {
          console.log("onItemClick");
      },
      'onCheckBoxClick': function (item: any) {
          console.log("onCheckBoxClick");
      },
      'onButtonClick': function (item: any) {
          console.log("onButtonClick");
      }
    };
  }

  sortComplaints(){
    function compare(a,b){
      if(a.disp_order == null && b.disp_order == null){
        return 0;
      }else if(a.disp_order == null){
        return 1;
      }else if(b.disp_order == null){
        return -1;
      }

      if(a.disp_order < b.disp_order)
        return -1;
      if(a.disp_order > b.disp_order)
        return 1;
      return 0;
    }

    this.complaintCatagories.sort(compare);
    this.showData=true
  }

  onClick(group: any, item: any){
    if(group.unhandled && group.unhandled==1){
      let alert = this.alertController.create({
        title: 'UNHANDLED_CATEGORY',
        subTitle: group.remarks,
        buttons: ['OK']
      });
      alert.present();
    }else if(item.unhandled && item.unhandled==1){
      let alert = this.alertController.create({
        title: 'UNHANDLED_CATEGORY',
        subTitle: item.remarks,
        buttons: ['OK']
      });
      alert.present();
    }else{
      this.navCtrl.push(AddComplaintsFormPage, {
        group,
        item
      });
    }
  }

  toggleGroup(group: any) {
    console.log(group);
    if(group.unhandled && group.unhandled==1){
      let alert = this.alertController.create({
        title: 'UNHANDLED_CATEGORY',
        subTitle: group.remarks,
        buttons: ['OK']
      });
      alert.present();
      return 0;
    }
    if(group.sub_catagory.length == 0){
      this.navCtrl.push(AddComplaintsFormPage, {
        group,
        item: {
          name: null
        }
      });
    }else if(group.sub_catagory.length == 1){
      this.navCtrl.push(AddComplaintsFormPage, {
        group,
        item: group.sub_catagory[0]
      });
    }else{
      group.show = !group.show;
      this.complaintCatagories.forEach(element => {
        if(group.id != element.id){
          element.show = false;
        }
      });
    }
  }

  isGroupShown(group: any) {
    return group.show;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddComplaintsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-complaints/add-complaints.ts